import { COUPON_OFFERS, REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import { RetrieveCoupon } from "../../common/utils/RetrieveCoupon";

function SuperCheapAutoTactical1Main() {
  const { loading, coupon } = RetrieveCoupon(COUPON_OFFERS.supercheapautotactical1);
  const redeemUrl = GLOBAL_CFG["supercheap-auto-tactical-1"].redeem.redeemUrl;

  return (
    <>
      {!loading && (
          <OnboardingPage
            partnerCfg={GLOBAL_CFG["supercheap-auto-tactical-1"]}
            redeemUrl={redeemUrl}
            coupon={coupon}
            rewardId={REWARD_OFFERING.supercheapautotactical1}
          />
      )}
    </>
  );
}

export default SuperCheapAutoTactical1Main;
